import { InputAdornment, TextField } from '@mui/material';
import { FaMagnifyingGlass } from 'react-icons/fa6';

export default function SearchField({ placeholder = 'Buscar…', value, onChange, sx, ...props }) {
    return (
        <TextField
            size="small"
            fullWidth
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            sx={sx}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start" sx={{ color: 'text.secondary' }}>
                        <FaMagnifyingGlass size={14} />
                    </InputAdornment>
                ),
            }}
            {...props}
        />
    );
}
